/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {MemberInfo} from '../models/MemberInfo';

export interface GetAvailableMembers$Request {
    accountId: number;
    emails: Array<string>;
}

export interface GetAvailableMembers$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAvailableMembersRequest = createAction<PayloadData<void, GetAvailableMembers$Request>>('GET_AVAILABLE_ACCOUNT_GROUP_MEMBERS__GET_AVAILABLE_MEMBERS__REQUEST');
export const getAvailableMembersSuccess = createAction<PayloadData<Array<MemberInfo>, GetAvailableMembers$Request>>('GET_AVAILABLE_ACCOUNT_GROUP_MEMBERS__GET_AVAILABLE_MEMBERS__SUCCESS');
export const getAvailableMembersFailure = createAction<PayloadData<Error, GetAvailableMembers$Request, true>>('GET_AVAILABLE_ACCOUNT_GROUP_MEMBERS__GET_AVAILABLE_MEMBERS__FAILURE');

export const getAvailableMembersActions = [
    getAvailableMembersRequest,
    getAvailableMembersSuccess,
    getAvailableMembersFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {Array<string>} meta.emails
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAvailableMembers = (meta: GetAvailableMembers$Request, config?: GetAvailableMembers$Config) => {
    const TRANSPORT_GET_PARAMS = {
        emails: meta.emails,
    };
    return {
        CALL_API: {
            types: getAvailableMembersActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/available-group-members`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

